import React from 'react'
import { Pipeline, WhenEnvValueMatches } from '@morningtrain/react-helpers'
import TriggerPipelineOnInactivity from 'widgets/auth/TriggerPipelineOnInactivity'
import NotifyAboutLogoutOnPipe from 'widgets/auth/NotifyAboutLogoutOnPipe'
import WaitUntilLogoutExpirationOnPipe from 'widgets/auth/WaitUntilLogoutExpirationOnPipe'
import LogOutOnPipe from 'widgets/auth/LogOutOnPipe'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import TriggerEventOnPipe from 'services/events/TriggerEventOnPipe'

export default function AutoLogout (props) {
  return (
    <WhenEnvValueMatches name='globals.is_impersonating' matches negate>
      <WhenDeviceAuthorized>
        <Pipeline>
          <TriggerPipelineOnInactivity />
          <NotifyAboutLogoutOnPipe />
          <WaitUntilLogoutExpirationOnPipe />
          <TriggerEventOnPipe name='auto-logout' />
          <LogOutOnPipe />
        </Pipeline>
      </WhenDeviceAuthorized>
    </WhenEnvValueMatches>
  )
}
